import useSWR from 'swr'

import type {CurrencyType} from '@pleo-io/deimos'

import {getDeimos} from './helpers'

import type {StaticTransferField} from '../types/static-transfer-field'

export type CurrenciesResponse = (StaticTransferField & {currency: CurrencyType})[]

export function useCurrencies(companyId?: string) {
    return useSWR<CurrenciesResponse, Error>(
        companyId ? `/rest/v1/telesto/companies/${companyId}/currencies` : null,
        getDeimos,
    )
}
